import Vue from 'vue'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import VueClipboard from 'vue-clipboard2'
import Vue2Filters from 'vue2-filters'
import Axios from 'axios'
import './assets/styles.css'
import moment from 'moment'
import { LicenseManager } from 'ag-grid-enterprise'

LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_LICENSE)

Vue.use(VueScrollTo)
Vue.use(VueClipboard)
Vue.use(Vue2Filters)

Vue.config.productionTip = false

// Now contains sensitive information
// console.log(process.env)

export const ENV = process.env

const API_PATH = process.env.VUE_APP_API_PATH ?? '/api'
export const MODELS_API = process.env.VUE_APP_MODELS_API
export const OPERA_URL = (MODELS_API || API_PATH) + '/opera'

export const AUTH_URL = (process.env.VUE_APP_ADMIN_URL || API_PATH) + '/auth'
export const ALERTS_URL = (process.env.VUE_APP_ALERTS_URL || API_PATH) + '/alerts'
export const SAFETY_URL = (process.env.VUE_APP_SAFETY_URL || API_PATH) + '/safety'
export const DESCRIPTORS_URL = (process.env.VUE_APP_SERVICES_URL || API_PATH) + '/descriptors'
export const HAZARD_URL = (process.env.VUE_APP_HAZARD_URL || API_PATH) + '/hazard'
export const SEARCH_URL = (process.env.VUE_APP_SEARCH_URL || API_PATH) + '/search'
export const SERVICES_URL = (process.env.VUE_APP_SERVICES_URL || API_PATH) + '/services'
export const TOXPRINTS_URL = (process.env.VUE_APP_TOXPRINTS_URL || API_PATH) + '/toxprints'
export const WEBTEST_URL = (process.env.VUE_APP_WEBTEST_URL || API_PATH) + '/webtest'
export const PREDICTOR_URL = (process.env.VUE_APP_PREDICTOR_URL || API_PATH) + '/predictor'
export const RESOLVER_URL = (process.env.VUE_APP_RESOLVER_URL || API_PATH) + '/resolver'
export const STDIZER_URL = (process.env.VUE_APP_STDIZER_URL || API_PATH) + '/stdizer'

export const PADEL_URL = (process.env.VUE_APP_SERVICES_URL || API_PATH) + '/padel'
export const MORDRED_URL = (process.env.VUE_APP_SERVICES_URL || API_PATH) + '/mordred'
export const RDKIT_URL = (process.env.VUE_APP_SERVICES_URL || API_PATH) + '/rdkit'

export const EPI_SUITE_URL = (process.env.VUE_APP_EPI_SUITE_URL || API_PATH) + '/episuite'
export const FEEDBACK_URL = (process.env.VUE_APP_FEEDBACK_URL || API_PATH) + '/feedback'

export const TURNSTILE_SITE_KEY = process.env.VUE_APP_TURNSTILE_SITE_KEY

export const CHET_URL = (process.env.VUE_APP_CHET_URL || '') + '/chet'
export const AMOS_URL = (process.env.VUE_APP_AMOS_URL || '') + '/amos'

const APP_NAME = process.env.VUE_APP_NAME

Vue.prototype.$axios = Axios.create({
  // withCredentials: true,
})

Vue.filter('truncate', function (text, length, clamp) {
  clamp = clamp || '...'
  const node = document.createElement('div')
  node.innerHTML = text
  const content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
})
Vue.filter('date', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
})

if (localStorage.xAuth) Vue.prototype.$axios.defaults.headers.common['X-Auth'] = localStorage.xAuth

export function getStructureImageUrl(structure, width, height) {
  if (structure) {
    if (typeof structure === 'string') {
      if (width) {
        return `${RESOLVER_URL}/render?query=${encodeURIComponent(structure)}&width=${width}&height=${height}`
      } else {
        return `${RESOLVER_URL}/render?query=${encodeURIComponent(structure)}`
      }
    } else if (typeof structure === 'object') {
      if (structure.smiles) {
        if (width) {
          return `${RESOLVER_URL}/render?smiles=${encodeURIComponent(structure.smiles)}&width=${width}&height=${height}`
        } else {
          return `${RESOLVER_URL}/render?smiles=${encodeURIComponent(structure.smiles)}`
        }
      } else if (structure.canonicalSmiles) {
        if (width) {
          return `${RESOLVER_URL}/render?smiles=${encodeURIComponent(
            structure.canonicalSmiles,
          )}&width=${width}&height=${height}`
        } else {
          return `${RESOLVER_URL}/render?smiles=${encodeURIComponent(structure.canonicalSmiles)}`
        }
      } else if (structure.sid) {
        if (width) {
          return `${RESOLVER_URL}/render?query=${encodeURIComponent(structure.sid)}&width=${width}&height=${height}`
        } else {
          return `${RESOLVER_URL}/render?query=${encodeURIComponent(structure.sid)}`
        }
      } else if (structure.cid) {
        return getDashboardImageUrl(structure.cid)
      }
    }
  }
}

export function getDashboardUrl(sid) {
  return `https://comptox.epa.gov/dashboard/dsstoxdb/results?search=${sid}`
}

export function getDashboardImageUrl(cid) {
  return `https://comptox.epa.gov/dashboard/dsstoxdb/compound_image_file?source=${cid.substr(8)}`
}

export function getDatedFilename(prefix, ext) {
  const now = new Date()
  return prefix + '-' + now.toISOString().substr(0, 19) + '.' + ext
}

export const dateFromObjectId = function (objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000)
}

export function openLink(url, target) {
  let element = document.createElement('a')
  element.setAttribute('href', url)
  element.setAttribute('target', target)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export function download(filename, data, format) {
  let opt
  if (format === 'xlsx') opt = { type: 'application/vnd.ms-excel;charset=utf-8' }
  else if (format === 'csv') opt = { type: 'text/csv' }
  else if (format === 'pdf') opt = { type: 'application/pdf' }
  else if (format === 'sdf') opt = { type: 'chemical/x-mdl-sdfile' }
  else if (format === 'json') opt = { type: 'application/json' }
  else opt = { type: 'text/plain' }

  let blob = new Blob([data], opt) // pass a useful mime type here
  let url = URL.createObjectURL(blob)

  let element = document.createElement('a')
  element.setAttribute('href', url)
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

export function getErrorMessage(error) {
  const responseStatus = error?.response?.status
  if (responseStatus === 413) {
    return 'The request entity is too large.'
  }
  const responseMessage = error?.response?.data?.detail || error?.response?.data?.message

  return responseMessage || error?.message || (typeof error === 'string' ? error : 'Unknown error')
}

export function roundup(value, digits) {
  if (!isNaN(value)) {
    const round = Math.round(Math.pow(10, digits))
    return Math.round((parseFloat(value) + Number.EPSILON) * round) / round
  }
}

export function isValidChemical(resolvedChemical) {
  return ['FOUND', 'CONVERTED'].includes(resolvedChemical.result) || resolvedChemical.chemId
}

export function isChemical(resolvedChemical) {
  return ['FOUND', 'CONVERTED', 'DUPLICATE'].includes(resolvedChemical.result) || resolvedChemical.chemId
}

export function prepareLinks(links) {
  return links
    .filter((l) => !l.name.startsWith('Sp') && !l.name.startsWith('MoNA'))
    .sort((x, y) => x.name.toLowerCase().localeCompare(y.name.toLowerCase()))
}

export const eventBus = new Vue()

document.title = APP_NAME || ''

router.afterEach((to) => {
  const pageTitle =
    to && to.meta && to.meta.title ? `${to.meta.title} - ${APP_NAME}` : APP_NAME || 'Cheminformatics Modules'
  document.title = pageTitle
})

new Vue({
  el: '#app',
  store,
  vuetify,
  router,
  render: (h) => h(App),
})
